import { RowSelectionState, Updater } from '@tanstack/react-table';
import { getRowId, isRowWithId } from '../utils';

interface UseGetSelectedRowOriginalDataProps<T> {
  data: T[];
}

export const useGetSelectedRowOriginalData = <T>({
  data,
}: UseGetSelectedRowOriginalDataProps<T>) => {
  const getSelectedRowOriginalData = (
    updater: Updater<RowSelectionState>,
    currentState: RowSelectionState = {},
    currentSelectedRowsOriginalData: T[] = []
  ) => {
    const newSelection =
      typeof updater === 'function' ? updater(currentState) : updater;

    const selectedIds = Object.entries(newSelection)
      .filter(([_, value]) => value)
      .map(([key]) => key);

    const filteredOldValues = currentSelectedRowsOriginalData.filter(
      value => isRowWithId(value) && selectedIds.includes(getRowId(value))
    ) as (T & { id: string })[];

    const selectedRows = [
      ...filteredOldValues,
      ...(data || []).filter(
        row =>
          isRowWithId(row) &&
          selectedIds.includes(getRowId(row)) &&
          !filteredOldValues.some(value => value.id === getRowId(row))
      ),
    ];

    return selectedRows;
  };

  return getSelectedRowOriginalData;
};
